import { Spin } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { MobileEmpty } from '@/components/mobile/MobileEmpty';
import * as departmentsApi from '@/services/api/departments';
import * as usersApi from '@/services/api/users';
import { useAuthStore } from '@/stores/auth.store';
import type { UserRecord } from '@/types/user';
import { findDepartmentNode } from '@/utils/department-tree';

export function EmployeeLeaderPage() {
  const user = useAuthStore((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [leader, setLeader] = useState<UserRecord | null>(null);
  const [departmentName, setDepartmentName] = useState<string>('—');

  const load = useCallback(async () => {
    if (!user?.leaderId) {
      setLeader(null);
      return;
    }

    setLoading(true);
    try {
      const [leaderUser, tree] = await Promise.all([
        usersApi.fetchUser(user.leaderId),
        departmentsApi.fetchDepartmentTree(),
      ]);
      setLeader(leaderUser);
      const dept = findDepartmentNode(tree, leaderUser.departmentId);
      setDepartmentName(dept?.name ?? '—');
    } catch {
      setLeader(null);
      setDepartmentName('—');
    } finally {
      setLoading(false);
    }
  }, [user?.leaderId]);

  useEffect(() => {
    void load();
  }, [load]);

  if (!user) {
    return null;
  }

  if (!user.leaderId) {
    return <MobileEmpty message="尚未配置直属领导，请联系管理员。" />;
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (!leader) {
    return <MobileEmpty message="无法加载直属领导信息。" />;
  }

  const jobTitle = leader.jobTitle?.trim() || '—';

  return (
    <div className="mobile-leader-card">
      <div className="mobile-leader-card__name">{leader.name}</div>
      <div className="mobile-leader-card__title">{jobTitle}</div>
      <div className="mobile-leader-card__dept">{departmentName}</div>
    </div>
  );
}
